/*
 * @Description: 
 * @Version: 2.0
 * @Autor: 一诺(丘汉文)
 * @Date: 2019-03-26 23:15:52
 * @Author: 一诺(丘汉文)
 * @LastEditors: 一诺(丘汉文)
 */
/**
 * import中的webpackChunkName，为按需加载生成的JS名称，请使用 [project-name]-[module-name]，示例如下
 */
export default [
  {
    path: '/',
    name:'/home',
    meta:{
        title:'首页'
    },
    component: () =>
      import ( /* webpackChunkName: "example-configuration-center" */ '../views/home/home.vue')
  },
  {
    path: '/home',
    name: '/home',
    meta: {
      title: '首页'
    },
    component: () =>
      import ( /* webpackChunkName: "example-configuration-center" */ '../views/home/home.vue')
  },
  {
    path: '/video',
    name: '/video',
    component: () =>
    import ( /* webpackChunkName: "example-aboult" */ '../views/home/video.vue')
  },
  {
    path: '/iframe/*',
    component: () => import(/* webpackChunkName: "yunjiadmin-system-system" */ '@/views/iframe/index')
  }
]